module.exports = __webpack_public_path__ + "img/dianliang.10a7546c.png";